import React from 'react'
import Status from '../../Components/Status/Status'
import { Oval } from 'react-loader-spinner'
import { useQuery } from 'react-query'
import { baseUrl, path } from '../../constants'
import axios from 'axios'
import dayjs from 'dayjs'

export default function Enrollments({}) {
    const { isLoading, error, data } = useQuery('fetchEnrolls', () =>
        axios(baseUrl + path.enrollments, {
        })
    )
    console.log(data?.data)
    return [
        <h1>Enrollments</h1>,
        isLoading ? (
            <div className='flex flex-col items-center gap-3'>
                <p className='text-black text-[15px]'>Loading data...</p>
                <Oval
                    visible={true}
                    height="30"
                    width="30"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                    />
            </div>
        ) : (
            <div className='w-full h-full flex flex-col bg-white rounded-sm p-4 gap-4 overflow-auto'>
            <div className='flex items-center justify-between'>
                <div className='flex gap-4 items-center'>
                    <div className='flex h-[40px] w-[300px] relative border-solid border-[#0000007f] border-[1px]'>
                        <input placeholder='Search students...' className='h-full w-full pl-5' />
                    </div>
                </div>
                <button className='px-5 py-2 bg-main text-white text-[12px] font-bold outline-none border-none bg-none'>Export Data</button>
            </div>
                <table className='w-full' cellPadding={10}>
                <thead>
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000068] bg-[#ededed]'>
                        <th align='left' className='p-2 text-[14px]'>First Name</th>
                        <th align='left' className='p-2 text-[14px]'>Las    t Name</th>
                        <th align='left' className='p-2 text-[14px]'>Course Title</th>
                        <th align='left' className='p-2 text-[14px]'>Price</th>
                        <th align='left' className='p-2 text-[14px]'>Instructor</th>
                        <th align='left' className='p-2 text-[14px]'>Enrolled Date</th>
                        <th align='left' className='p-2 text-[14px]'>Status</th>
                        {/* <th align='left' className='p-2 text-[14px]'>Actions</th> */}
                    </tr>
                </thead>
                <tbody>
                    {(data?.data?.enrolls || []).map(row => (
                        <tr className='border-b-solid border-b-[1px] border-b-[#00000068]'> 
                            <td className='text-[13px] p-2'>{row.user?.firstName}</td>
                            <td className='text-[13px] p-2'>{row.user?.lastName}</td>
                            <td className='text-[13px] p-2'>{row.course?.title}</td>
                            <td className='text-[13px] p-2'><span className='text-[#00ff00] font-bold bg-black px-2 py-1 rounded-md'>{row.course?.price} ETB</span></td>
                            <td className='text-[13px] p-2'>{row.course?.instructor?.firstName}</td>
                            <td className='text-[13px] p-2'>{dayjs(row.createdAt).format('MM/DD/YY HH:mm:ss')}</td>
                            <td className='text-[13px] p-2'>{row.active ? 'Active' : 'InActive'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        )
    ]
}
